/**
 * Post-login gating order: a member must accept the current terms & conditions and (if applicable)
 * the annual declaration before reaching the app. This is the single source of truth for that
 * decision, shared by:
 *   - Login (redirects here right after authenticating), and
 *   - the TPR wrapper (a route guard, so pressing back / navigating directly can't bypass a gate).
 *
 * Staff are exempt server-side (the login response already reports both accepted), so they resolve
 * to `null` here too. Undefined acceptance is treated as NOT accepted — we never silently pass.
 */
export interface LoginGateState {
  termsAccepted?: boolean;
  annualDeclarationAccepted?: boolean;
  currentTermsVersion?: number;
}

/** The path the member must be sent to next, or `null` when all gates are cleared. */
export function nextGatePath(state: LoginGateState): string | null {
  if (!state.termsAccepted) {
    const version = state.currentTermsVersion ?? 1;
    const next = state.annualDeclarationAccepted ? "" : "&next=/login/declaration";
    return `/login/terms?v=${version}${next}`;
  }
  if (!state.annualDeclarationAccepted) {
    return "/login/declaration";
  }
  return null;
}
